module.exports = __webpack_public_path__ + "static/media/Vault PLM.52724cfe.png";